import { log } from '../utils';

export function createDialogShadowPortal(styles: CSSStyleSheet | string) {
  const root = document.createElement('div');
  root.id = 'services-portal-root';
  document.body.appendChild(root);

  const shadowRoot = root.attachShadow({ mode: 'open' });

  applyStylesToShadowRoot(shadowRoot, styles);
}

export function createWidgetShadowRoot(
  rootId: string,
  styles: CSSStyleSheet | string,
) {
  const mount = document.getElementById(rootId);

  if (!mount) {
    log.error(`Widget root element #${rootId} not found.`);
    return null;
  }

  const shadowRoot = mount.attachShadow({ mode: 'open' });

  applyStylesToShadowRoot(shadowRoot, styles);
  return shadowRoot;
}

function applyStylesToShadowRoot(
  shadowRoot: ShadowRoot,
  styles: CSSStyleSheet | string,
) {
  if (styles instanceof CSSStyleSheet) {
    (shadowRoot as any).adoptedStyleSheets = [styles];
  } else {
    const style = document.createElement('style');
    style.textContent = styles;
    shadowRoot.appendChild(style);
  }
}
